<template>
  <header class="sitenav" :class="{ 'sitenav-interior': esInterior }">
    <div class="container-fluid" v-if="mostrarMenu">
      <div class="row">
        <div class="col-12 w-100">
          <b-navbar toggleable="lg" type="light">
            <b-navbar-brand to="/" v-if="mostrarLogo">
              <img
                class="img-fluid"
                src="../assets/imgs/playasol/cementos-chihuahua.png"
                alt="Verano con sabor a cinepolis"
              />
            </b-navbar-brand>
            <b-navbar-brand to="/" v-else>
              <img
                v-if="home === false"
                class="img-fluid"
                src="../assets/imgs/playasol/cementos-chihuahua.png"
                alt="Verano con sabor a cinepolis"
              />
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <template>
                  <!-- <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold"
                    href="/dashboard"
                    >Registrar ticket</b-nav-item
                  > -->

                  <!-- <b-nav-item
                    class=" btnrojo text-center pt-2 pt-lg-4 bold"
                    to="/mis-participaciones"
                  >Mis participaciones</b-nav-item>

                  <b-nav-item class=" btnrojo text-center pt-2 pt-lg-4 bold" href="/ganadores">Ganadores</b-nav-item> -->

                  <!-- <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/ganadores"
                  >
                    Ganadores
                  </b-nav-item> -->
                </template>

                <template
                  v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
                >
                  <!-- FIN PROMO 2026: se oculta Registrar ticket porque Dashboard quedó deshabilitado.
                       Para reactivar registro de tickets, quitar v-if="false". -->
                  <b-nav-item
                    v-if="false"
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/dashboard"
                  >
                    Registrar ticket
                  </b-nav-item>

                  
                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/mis-participaciones"
                  >
                    Mis participaciones
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/folios-de-participacion"
                  >
                    Folios de participación
                  </b-nav-item>

                  <!-- <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/premios"
                  >
                    Premios
                  </b-nav-item> -->

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/ganadores"
                  >
                    Ganadores
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold"
                    @click="logout()"
                  >
                    Cerrar sesión
                  </b-nav-item>
                </template>

                <template v-else>
                  <b-nav-item
                    v-if="mostrarInicio === true"
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/"
                  >
                    Inicio
                  </b-nav-item>

                  <b-nav-item
                    v-if="mostrarInicio === false"
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    href="./#inicia-sesion"
                  >
                    Login
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/folios-de-participacion"
                  >
                    Folios de participación
                  </b-nav-item>

                  <!-- <b-nav-item
                    v-if="mostrarInicio === false"
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    href="./#registro"
                  >
                    Registro
                  </b-nav-item> -->

                  <!-- <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/premios"
                  >
                    Premios
                  </b-nav-item> -->

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    to="/ganadores"
                  >
                    Ganadores
                  </b-nav-item>

                  <b-nav-item
                    class="btnrojo text-center pt-2 pt-lg-4 bold cerrarsesion"
                    href="/tycos-2026.pdf"
                    target="_blank"
                  >
                    Términos y Condiciones
                  </b-nav-item>
                </template>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import * as fb from "../firebase";
import { mapState } from "vuex";
export default {
  data() {
    return {
      uid: null,
      mostrarLogo: true,
      mostrarMenu: true,
      mostrarInicio: false,
      home: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
    esInterior() {
      return !["Home", "Login"].includes(this.$route.name);
    },
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      if (
        this.$route.name == "Dashboard" ||
        this.$route.name == "Resultado" ||
        this.$route.name == "Mecanica"
      ) {
        this.mostrarLogo = false;
      } else {
        this.mostrarLogo = true;
      }

      if (this.$route.name == "Home" || this.$route.name == "Login") {
        this.home = true;
      } else {
        this.home = false;
      }
      console.log({ home: this.home });

      if (
        this.$route.name == "Premios" ||
        this.$route.name == "FoliosParticipacion" ||
        this.$route.name == "Ganadores" ||
        this.$route.name == "Mecanica"
      ) {
        this.mostrarInicio = true;
      } else {
        this.mostrarInicio = false;
      }

      if (this.$route.name == "Dinamica") {
        this.mostrarMenu = false;
      } else {
        this.mostrarMenu = true;
      }
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    //console.log({user: this.userProfile})
    this.init();
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    init() {
      if (
        this.$route.name == "Dashboard" ||
        this.$route.name == "Resultado" ||
        this.$route.name == "Mecanica"
      ) {
        this.mostrarLogo = false;
      }

      // if (this.$route.name == "Login") {
      //   this.home = true;
      // } else {
      //   this.home = false;
      // }

      if (
        this.$route.name == "Premios" ||
        this.$route.name == "FoliosParticipacion" ||
        this.$route.name == "Ganadores" ||
        this.$route.name == "Mecanica"
      ) {
        this.mostrarInicio = true;
      } else {
        this.mostrarInicio = false;
      }

      if (this.$route.name == "Dinamica") {
        this.mostrarMenu = false;
      }

      try {
        this.uid = fb.auth.currentUser.uid;
      } catch (e) {
        //
      }

      try {
        //console.log({useremail: this.userProfile.email})
      } catch (e) {
        //
      }
    },
  },
};
</script>
